"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[775,384],{

/***/ 8384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BookACall = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        "aria-label": "Open a new tab to book a 15 minute call",
        className: "text-md   h-full w-full font-bold underline  transition-colors hover:text-brand-pink hover:no-underline  " + props.className,
        href: "https://calendly.com/scrumify-at/15min",
        children: "Book a 15 min call"
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BookACall);


/***/ }),

/***/ 7775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Member; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/BookACall.tsx
var BookACall = __webpack_require__(8384);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-feather/dist/icons/mail.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Mail = (0,react.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/react.createElement("path", {
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "22,6 12,13 2,6"
  }));
});
Mail.propTypes = {
  color: (prop_types_default()).string,
  size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
};
Mail.displayName = 'Mail';
/* harmony default export */ var mail = (Mail);
// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/linkedin.js
var linkedin = __webpack_require__(9318);
;// CONCATENATED MODULE: ./node_modules/react-feather/dist/icons/twitter.js
function twitter_extends() { twitter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_extends.apply(this, arguments); }

function twitter_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = twitter_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function twitter_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Twitter = (0,react.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = twitter_objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react.createElement("svg", twitter_extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/react.createElement("path", {
    d: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
  }));
});
Twitter.propTypes = {
  color: (prop_types_default()).string,
  size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
};
Twitter.displayName = 'Twitter';
/* harmony default export */ var twitter = (Twitter);
;// CONCATENATED MODULE: ./node_modules/react-feather/dist/icons/globe.js
function globe_extends() { globe_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return globe_extends.apply(this, arguments); }

function globe_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = globe_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function globe_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Globe = (0,react.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = globe_objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react.createElement("svg", globe_extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/react.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/react.createElement("line", {
    x1: "2",
    y1: "12",
    x2: "22",
    y2: "12"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
  }));
});
Globe.propTypes = {
  color: (prop_types_default()).string,
  size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
};
Globe.displayName = 'Globe';
/* harmony default export */ var globe = (Globe);
;// CONCATENATED MODULE: ./node_modules/react-feather/dist/icons/headphones.js
function headphones_extends() { headphones_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return headphones_extends.apply(this, arguments); }

function headphones_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = headphones_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function headphones_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Headphones = (0,react.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = headphones_objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react.createElement("svg", headphones_extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/react.createElement("path", {
    d: "M3 18v-6a9 9 0 0 1 18 0v6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
  }));
});
Headphones.propTypes = {
  color: (prop_types_default()).string,
  size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
};
Headphones.displayName = 'Headphones';
/* harmony default export */ var headphones = (Headphones);
// EXTERNAL MODULE: ./lib/Transitions.ts
var Transitions = __webpack_require__(8080);
;// CONCATENATED MODULE: ./components/Socials.tsx




const Socials = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                "aria-label": "Write an email to " + props.userName,
                href: "mailto:" + props.email,
                className: "text-white hover:text-brand-pink",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mail, {
                    className: "stroke-brand-pink hover:scale-110 " + (0,Transitions/* getOpacityFromBottomTransition */.$)(props.inView)
                })
            }),
            props.linkedin && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                "aria-label": "Open Linkedin of " + props.userName,
                href: props.linkedin,
                className: "text-white hover:text-brand-pink",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin/* default */.Z, {
                    className: "stroke-brand-pink hover:scale-110 " + (0,Transitions/* getOpacityFromBottomTransition */.$)(props.inView)
                })
            }),
            props.twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                href: props.twitter,
                "aria-label": "Open twitter of " + props.userName,
                className: "text-white hover:text-brand-pink",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter, {
                    className: "stroke-brand-pink hover:scale-110" + (0,Transitions/* getOpacityFromBottomTransition */.$)(props.inView)
                })
            }),
            props.website && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: props.website,
                target: "_blank",
                rel: "noreferrer",
                "aria-label": "Open website of " + props.userName,
                className: "text-white hover:text-brand-pink",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(globe, {
                    className: "stroke-brand-pink hover:scale-110 " + (0,Transitions/* getOpacityFromBottomTransition */.$)(props.inView)
                })
            }),
            props.music && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: props.music,
                target: "_blank",
                rel: "noreferrer",
                "aria-label": "Open website of " + props.userName,
                className: "text-white hover:text-brand-pink",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headphones, {
                    className: "stroke-brand-pink hover:scale-110 " + (0,Transitions/* getOpacityFromBottomTransition */.$)(props.inView)
                })
            })
        ]
    });
};
/* harmony default export */ var components_Socials = (Socials);

;// CONCATENATED MODULE: ./components/Member.tsx






const Member = (props)=>{
    const memberImageInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "-40% 0px"
    });
    const memberMobileImageInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "-40% 0px"
    });
    const memberTextInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "-40% 0px"
    });
    const socialsInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "-40% 0px"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: memberTextInView.ref,
        className: "flex h-full w-full flex-col   overflow-hidden " + props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " translate-transform transform-opacity flex flex-col items-center justify-center  text-center duration-500  md:w-1/2 lg:px-8 " + (!memberTextInView.inView && props.textTranslationDireciton + " opacity-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-gradient-to-l from-brand-pink to-brand-turquoise bg-clip-text p-2  pt-4 font-molle text-xl font-extrabold text-transparent sm:text-3xl md:bg-gradient-to-r  lg:mt-8 lg:text-4xl",
                        children: props.slogan
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " md:mt-20 bg-gradient-to-l from-brand-pink to-brand-turquoise  bg-clip-text  font-mono  text-3xl font-extrabold text-transparent text-white sm:text-4xl md:bg-gradient-to-r lg:mt-8 lg:text-5xl",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: memberMobileImageInView.ref,
                        className: "w-full md:hidden ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: props.image,
                            alt: props.title,
                            width: 1024,
                            height: 1920,
                            className: "duration-500 " + (!memberMobileImageInView.inView && props.imageTranslationDirection + " opacity-0")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " shadowedText mb-8 mt-4 text-white  text-center lg:mt-14",
                        children: props.children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: socialsInView.ref,
                        className: "flex w-full flex-row justify-evenly",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Socials, {
                            inView: socialsInView.inView,
                            email: props.email,
                            twitter: props.twitter,
                            linkedin: props.linkedin,
                            website: props.website,
                            userName: props.title,
                            music: props.music
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 transition-opacity delay-500 duration-1000  " + (!socialsInView.inView && " opacity-0  "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookACall["default"], {
                            className: "text-white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: memberImageInView.ref,
                className: "md:w-1/2 hidden md:block ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: props.image,
                    alt: props.title,
                    width: 1024,
                    height: 1920,
                    className: "duration-500 " + (!memberImageInView.inView && props.imageTranslationDirection + " opacity-0")
                })
            })
        ]
    });
};
/* harmony default export */ var components_Member = (Member);


/***/ }),

/***/ 9318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Linkedin = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: "2",
    y: "9",
    width: "4",
    height: "12"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "2"
  }));
});
Linkedin.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
Linkedin.displayName = 'Linkedin';
/* harmony default export */ __webpack_exports__["Z"] = (Linkedin);

/***/ })

}]);